// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"TooltipTwo_tooltipContent__S9X8u"};